import { useState } from "react";

import { DashboardContext } from "./DashboardContext";

import completedResultsIcon from "../../assets/imgs/icons/completed_results.svg";
import deceasedPatientsIcon from "../../assets/imgs/icons/deceased_patients.svg";
import patientsMeasuredIcon from "../../assets/imgs/icons/patients_measured.svg";
import plannedOutcomesIcon from "../../assets/imgs/icons/planned_outcomes.svg";
import pendingPatientsIcon from "../../assets/imgs/icons/pending_patients.svg";
import totalPatientsIcon from "../../assets/imgs/icons/total_patients.svg";
import pendingScalesIcon from "../../assets/imgs/icons/pending_scales.svg";
import pendingAlertsIcon from "../../assets/imgs/icons/pending_alerts.svg";
import startedTracksIcon from "../../assets/imgs/icons/started_tracks.svg";
import warninglertsIcon from "../../assets/imgs/icons/warning_alerts.svg";
import patientsFillIcon from "../../assets/imgs/icons/patients_fill.svg";
import readmissionsIcon from "../../assets/imgs/icons/readmissions.svg";
import managerFillIcon from "../../assets/imgs/icons/manager_fill.svg";
import totaLinesIcon from "../../assets/imgs/icons/total_lines.svg";
import patientsIcon from "../../assets/imgs/icons/patients.svg";

export const DashboardProvider = ({ children }) => {
  const basicStatsPath = "/recu/stats";
  const desenlacesStatsPath = `${basicStatsPath}/desenlaces`;
  const contigoStatsPath = `${basicStatsPath}/contigo`;

  const [dataCards, setDataCards] = useState([
    {
      detail: "Lineas activas",
      icon: totaLinesIcon,
      type: "lines",
      path: basicStatsPath,
      backendField: "totalActiveServiceLines"
    },
    {
      detail: "Pacientes",
      icon: patientsIcon,
      type: "patients",
      path: basicStatsPath,
      backendField: "totalPatients"
    },
  ]);

  const [desenlacesDetailCards, setDesenlacesDetailCards] = useState([
    {
      detail: "Pacientes activos",
      icon: totalPatientsIcon,
      color: "primary",
      type: "activePatients",
      path: desenlacesStatsPath,
      backendField: "totalPatients",
    },
    {
      detail: "Desenlaces diligenciados",
      icon: completedResultsIcon,
      color: "primary",
      type: "filledScales",
      path: desenlacesStatsPath,
      backendField: "totalPlans",
    },
    {
      detail: "Desenlaces planeados",
      icon: plannedOutcomesIcon,
      color: "primary",
      type: "plannedScales",
      path: desenlacesStatsPath,
      backendField: "totalPlans",
    },
    {
      detail: "Pacientes fallecidos",
      icon: deceasedPatientsIcon,
      color: "alert",
      type: "deceasedPatients",
      path: desenlacesStatsPath,
      backendField: "totalPatients",
    },
    {
      detail: "Pacientes medidos",
      icon: patientsMeasuredIcon,
      color: "primary",
      type: "measuredPatients",
      path: desenlacesStatsPath,
      backendField: "totalPatients",
    },
    {
      detail: "Pacientes pendientes",
      icon: pendingPatientsIcon,
      color: "alert",
      type: "pendingPatients",
      path: desenlacesStatsPath,
      backendField: "totalPatients",
      timePeriod: "future",
    },
    {
      detail: "Desenlaces pendientes por medir",
      icon: pendingScalesIcon,
      color: "alert",
      type: "pendingScales",
      path: desenlacesStatsPath,
      backendField: "totalPlans",
      timePeriod: "future",
    },
  ]);

  const [contigoDetailCards, setContigoDetailCards] = useState([
    {
      detail: "Pacientes en monitoreo",
      icon: totalPatientsIcon,
      color: "primary",
      type: "trackingPatients",
      path: contigoStatsPath,
      backendField: "patientsTracking",
    },
    {
      detail: "Monitoreos Iniciados",
      icon: startedTracksIcon,
      color: "primary",
      type: "totalTracks",
      path: contigoStatsPath,
      backendField: "totalTracks",
    },
    {
      detail: "Monitoreos finalizados",
      icon: completedResultsIcon,
      color: "primary",
      type: "finishedTracks",
      path: contigoStatsPath,
      backendField: "totalFinishedTracks",
    },
    {
      detail: "Formularios diligenciados",
      icon: completedResultsIcon,
      color: "primary",
      type: "filledPlans",
      path: contigoStatsPath,
      backendField: "totalFilledPlans",
    },
    {
      detail: "Encuestas de Gestores",
      icon: managerFillIcon,
      color: "secondary",
      type: "filledByManager",
      path: contigoStatsPath,
      backendField: "totalFilledByManager",
    },
    {
      detail: "Encuestas de Pacientes",
      icon: patientsFillIcon,
      color: "tertiary",
      type: "filledByPatient",
      path: contigoStatsPath,
      backendField: "totalFilledByPatient",
    },
    {
      detail: "Seguimiento alertas gestionadas",
      icon: pendingAlertsIcon,
      color: "warning",
      type: "alertsMonitoring",
      path: contigoStatsPath,
      backendField: "totalAlertsTracked",
    },
    {
      detail: "Pacientes con alerta activa",
      icon: warninglertsIcon,
      color: "primary",
      type: "onWarningPatients",
      path: contigoStatsPath,
      backendField: "totalPatientsWithAlert",
    },
    {
      detail: "Reingresos",
      icon: readmissionsIcon,
      color: "alert",
      type: "readmissions",
      path: contigoStatsPath,
      backendField: "totalReadmissions",
    },
    {
      detail: "NPS diligenciados",
      icon: completedResultsIcon,
      color: "primary",
      type: "npsFilled",
      path: contigoStatsPath,
      backendField: "totalNPSFilled",
    },
    {
      detail: "NPS",
      icon: warninglertsIcon,
      color: "primary",
      type: "npsScore",
      path: contigoStatsPath,
      backendField: "npsScore",
    },
  ]);

  return (
    <DashboardContext.Provider
      value={{
        dataCards, setDataCards,
        desenlacesDetailCards, setDesenlacesDetailCards,
        contigoDetailCards, setContigoDetailCards
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
